import { defineStore } from 'pinia'
import { ref } from 'vue'

import type { CustomerPlan } from './planTypes'

export const usePlanStore = defineStore('plan', () => {
  const customerPlan = ref<CustomerPlan | null>(null)
  const hasCustomerPlanLoaded = ref(false)
  const customerPlanFetchError = ref<string | null>(null)

  const setCustomerPlan = (plan: CustomerPlan): void => {
    customerPlan.value = plan
    hasCustomerPlanLoaded.value = true
    customerPlanFetchError.value = null
  }

  const clearCustomerPlan = (): void => {
    customerPlan.value = null
    hasCustomerPlanLoaded.value = false
    customerPlanFetchError.value = null
  }

  const setCustomerPlanFetchError = (error: string): void => {
    customerPlanFetchError.value = error
  }

  return {
    customerPlan,
    hasCustomerPlanLoaded,
    customerPlanFetchError,
    setCustomerPlan,
    clearCustomerPlan,
    setCustomerPlanFetchError,
  }
})
